import { Injectable } from '@angular/core';
import { CART_IS_PREPAID_SESSION_KEY, setCartIsPrepaidInSession } from 'app/core/constants/packages-flow.constants';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WebStorage {

    public StoredLead = new BehaviorSubject<any>(sessionStorage.getItem('LeadEntityID') ? sessionStorage.getItem('LeadEntityID') : 0);
    public CartInfo = new BehaviorSubject<any>(sessionStorage.getItem('cartInfo') ? JSON.parse(sessionStorage.getItem('cartInfo')) : 0);
    public CurrentPage = new BehaviorSubject<any>(sessionStorage.getItem('pageName'));
    public CustomerCoordinates = new BehaviorSubject<any>(sessionStorage.getItem('CustomerCoordinates') ? JSON.parse(sessionStorage.getItem('CustomerCoordinates')) : 0);
    public CustomerGoogleAddress = new BehaviorSubject<any>(sessionStorage.getItem('CustomerGoogleAddress') ? sessionStorage.getItem('CustomerGoogleAddress') : 0);
    public AvailablePackages = new BehaviorSubject<any>(sessionStorage.getItem('AvailablePackages') ? JSON.parse(sessionStorage.getItem('AvailablePackages')) : 0);
    public SelectedPackage = new BehaviorSubject<any>(sessionStorage.getItem('selectedPackage') ? JSON.parse(sessionStorage.getItem('selectedPackage')) : 0);
    public SuspendedCustomerBillingItems = new BehaviorSubject<any>(sessionStorage.getItem('SuspendedCustomerBillingItems') ? JSON.parse(sessionStorage.getItem('SuspendedCustomerBillingItems')) : 0);
    public CustomerInProgressItems = new BehaviorSubject<any>(sessionStorage.getItem('CustomerInProgressItems') ? JSON.parse(sessionStorage.getItem('CustomerInProgressItems')) : 0);
    public CustomerBillingItems = new BehaviorSubject<any>(sessionStorage.getItem('CustomerBillingItems') ? JSON.parse(sessionStorage.getItem('CustomerBillingItems')) : 0);
    public CustomerName = new BehaviorSubject<any>(0);
    public ActiveCustomerServices = new BehaviorSubject<any>(0);


    private cartProducts: Array<any> = [];
    private price: number;

    public updated: boolean = false;

    /**
     * Available Packages function
     * @param packages
     */
    public async StorePackages(packagesValue: any) {
        // //console.log(packagesValue);
        this.AvailablePackages.next(packagesValue);
        sessionStorage.setItem('AvailablePackages', JSON.stringify(packagesValue));
    }

    /**
   * Selected Packages function
   * @param packages
   */
    public StoreSelectedPackage(packagesValue: any): void {
    this.SelectedPackage.next(packagesValue);
    sessionStorage.setItem('selectedPackage', JSON.stringify(packagesValue));
    }

    /**
     * Set LeadEntityID
     * @param leadEntityID
     */
    public SetLeadEntityID(leadEntityID: number): void {
        this.StoredLead.next(leadEntityID);
        sessionStorage.setItem('LeadEntityID', JSON.stringify(leadEntityID));
    }

    /**
     * Set Customer Coordinates
     * 
     */
    public SetCustomerCoordinates(cords: any) {
        sessionStorage.removeItem('CustomerCoordinates');
        this.CustomerCoordinates.next(cords)
        sessionStorage.setItem('CustomerCoordinates', JSON.stringify(cords));
    }
      
    /**
     * Set Customer Google Address
     * 
     */
    public SetCustomerGoogleAddress(place: any) {
        sessionStorage.removeItem('CustomerGoogleAddress');
        this.CustomerGoogleAddress.next(place)
        sessionStorage.setItem('CustomerGoogleAddress', JSON.stringify(place));
    }

    /**
     * Set Customer Service
     * 
     */
    public SetCustomerService(service: any) {
      this.ActiveCustomerServices.next(service)
    }

    /**
   * Clear Packages function
   * 
   */
public ClearPackages(): void {
  this.AvailablePackages.next(null);
}


      /**
  * Update Cart Badge function
  * @param value 
  * @param PackageEntityID 
  * @param LeadEntityID 
  */
  public async UpdateCart(value: string, item: any, LeadEntityID: any): Promise<any> {
    this.updated = false;

    //console.log(this.CartInfo.value)
    if (this.CartInfo?.value?.length != 0 && this.CartInfo?.value) {
      this.cartProducts = await this.CartInfo.value;
    } else {
      this.cartProducts = [];
    }
    if (value == 'add') {
      // SUDO-17664: a cart belongs to one lead. Drop items left over from an earlier journey in
      // this session (e.g. a move order), otherwise pages that read cart[0] fall back to the old
      // lead and package.
      const currentLeadItems = this.cartProducts.filter((x: any) => String(x?.LeadEntityID) === String(LeadEntityID));
      if (currentLeadItems.length !== this.cartProducts.length) {
        this.cartProducts = currentLeadItems;
        this.CartInfo.next(this.cartProducts);
        sessionStorage.setItem('cartInfo', JSON.stringify(this.cartProducts));
      }

      // create object to be stored
      const packageExists = this.cartProducts.some((x: any) => x.PackageEntityID === item?.PackageEntityID);

      //console.log(packageExists)
 
      if (!packageExists) {

        if (item?.RecurringTotal) {
          this.price = item?.RecurringTotal
        } else {
          this.price = item?.Billing_PriceIncl
        }
        // create object to be stored
        let packageToCart = {
          PackageEntityID: item?.PackageEntityID,
          LeadEntityID: LeadEntityID,
          Price: this.price
        };

        this.cartProducts.push(packageToCart);
        this.CartInfo.next(this.cartProducts);
        sessionStorage.setItem('cartInfo', JSON.stringify(this.cartProducts));
        setCartIsPrepaidInSession(item);
        return true;
      }else{
        return false;
      }
    } else {

      // filter the package

      const filteredPackages = this.cartProducts.filter((x: any) => x.PackageEntityID !== item?.PackageEntityID);
      this.CartInfo.next(filteredPackages);
      // store in local and subject
      sessionStorage.setItem('cartInfo', JSON.stringify(filteredPackages));
      if (!filteredPackages.length) {
        sessionStorage.removeItem(CART_IS_PREPAID_SESSION_KEY);
      }

    }
  }




  /**
   * Set Customer Name
   * 
   */
  public setCustomerName(name: string) {
    this.CustomerName.next(name)
  }

    /**
   * Set Current Page
   * 
   */
    public SetCurrentPage(pageName: string): void {
      this.CurrentPage.next(pageName);
      sessionStorage.setItem('pageName', pageName);
    }

  /**
   * Set Customer Billing Items
   * 
   */
  public SetSuspendedCustomerBillingItems(BillingItems: any): void {
    sessionStorage.removeItem('SuspendedCustomerBillingItems');
    this.SuspendedCustomerBillingItems.next(BillingItems);
    sessionStorage.setItem('SuspendedCustomerBillingItems', JSON.stringify(BillingItems));
  }

    /**
   * Set Customer Billing Items
   * 
   */
    public SetCustomerBillingItems(BillingItems: any): void {
      sessionStorage.removeItem('CustomerBillingItems');
      this.CustomerBillingItems.next(BillingItems);
      sessionStorage.setItem('CustomerBillingItems', JSON.stringify(BillingItems));
    }

    /**
   * Set Customer Billing Items
   * 
   */
    public GetCustomerBillingItems() {
      return this.CustomerBillingItems
    }


  /**
   * Set Customer In Progress Leads
   * 
   */
  public SetCustomerInProgressLeads(InProgress: any): void {
    sessionStorage.removeItem('CustomerInProgressItems');
    // make sure its clear before saving new, otherwise double will be saved
    this.CustomerInProgressItems.next(InProgress);
    sessionStorage.setItem('CustomerInProgressItems', JSON.stringify(InProgress));
  }

  /**
  * Set Customer Coordinates
  * 
  */
  public setCustomerCoordinates(cords: any) {
    sessionStorage.removeItem('CustomerCoordinates');
    this.CustomerCoordinates.next(cords)
    sessionStorage.setItem('CustomerCoordinates', JSON.stringify(cords));
  }

  

}